"use client";

import { create } from "zustand";

/** Backs the app-wide "Access Restricted" modal — shown for any 403 the API returns. */
interface AccessRestrictedState {
  isOpen: boolean;
  message: string | null;
  show: (message: string) => void;
  hide: () => void;
}

export const useAccessRestrictedStore = create<AccessRestrictedState>((set) => ({
  isOpen: false,
  message: null,
  show: (message) => set({ isOpen: true, message }),
  hide: () => set({ isOpen: false, message: null }),
}));
